export type TabType = 'affiliate' | 'club' | 'customer';

export const getTitleByActiveTab = (activeTab: TabType): string => {
  const titleMap: Record<TabType, string> = {
    affiliate: 'configurationManagement.charges.table.affiliateCharges',
    club: 'configurationManagement.charges.table.clubCharges',
    customer: 'configurationManagement.charges.table.customerCharges',
  };
  return titleMap[activeTab] ?? 'configurationManagement.charges.table.affiliateCharges';
};
